import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

// TinyMCE 7 self-hosted — import du core + thème/modèle/icônes/plugins pour que window.tinymce
// soit défini localement et ne contacte JAMAIS le cloud TinyMCE (offline, GPL).
import 'tinymce/tinymce';
import 'tinymce/themes/silver';
import 'tinymce/models/dom';
import 'tinymce/icons/default';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/table';

/**
 * Éditeur riche partagé basé sur TinyMCE 7 self-hosted (GPL, offline).
 * ControlValueAccessor : utilisable avec formControlName ou [(ngModel)].
 * Expose (editorInit) pour récupérer l'instance (ex: insertion de variables au curseur).
 */
@Component({
  selector: 'app-rich-text-editor',
  standalone: false,
  template: `
    <editor
      [init]="editorConfig"
      [(ngModel)]="value"
      (ngModelChange)="onChange($event)"
      (onBlur)="onTouched()"
      (onInit)="editorInit.emit($event.editor)"
    ></editor>
  `,
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => RichTextEditorComponent), multi: true },
  ],
})
export class RichTextEditorComponent implements ControlValueAccessor {
  @Input() minHeight = 420;
  @Output() editorInit = new EventEmitter<any>();

  value = '';
  onChange: (v: any) => void = () => {};
  onTouched: () => void = () => {};

  get editorConfig() {
    return {
      base_url: '/tinymce',           // assets copiés via angular.json
      suffix: '.min',
      license_key: 'gpl',             // GPL self-hosted, aucun appel cloud
      promotion: false,
      branding: false,
      menubar: false,
      statusbar: false,
      height: this.minHeight,
      plugins: 'advlist autolink lists link charmap searchreplace visualblocks code fullscreen table',
      toolbar: 'undo redo | blocks fontsize | bold italic underline strikethrough | forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link table charmap | removeformat code fullscreen',
      directionality: 'ltr' as const,
    };
  }

  writeValue(v: any): void { this.value = v || ''; }
  registerOnChange(fn: (v: any) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
}
